import LocaleString from './locale-string';

export default ( LocaleString ) ;
